import React, { PureComponent } from "react";

export default class LightboxThumb extends PureComponent {
  render() {
    const { alt, src, onClick, selected } = this.props;
    return (
      <img
        role="Button"
        alt={alt}
        className="hvr-shrink"
        style={{
          opacity: selected ? 1 : 0.5,
          outline: selected ? "2px solid white" : "none",
          maxHeight: 200,
          margin: "0 6px 6px 0",
          cursor: "pointer",
        }}
        onClick={onClick}
        src={src}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/textureModal/LightboxThumb.js